'use strict';

var AnimationIntro = {
	$root: $('.intro'),
	scrollArrowTimeline: new TimelineMax(),
	isArrowAnimating: true,
	selectors: {
		introScroll: '.intro__scroll',
		introScrollArrow: '.intro__scroll-arrow'
	},

	vars: function vars() {
		this.$introScroll = $(this.selectors.introScroll);
		this.$introScrollArrow = $(this.selectors.introScrollArrow);
	},
	initHandler: function initHandler() {
		this.vars();
		this.scrollTriggerAnim();
		this.bindEvents();
	},
	bindEvents: function bindEvents() {
		var _this = this;

		this.$introScroll.hover(function () {
			_this.isArrowAnimating = false;
		}, function () {
			_this.isArrowAnimating = true;
			_this.scrollArrowTimeline.play(0);
		});
	},
	scrollTriggerAnim: function scrollTriggerAnim() {
		var _this2 = this;

		this.scrollArrowTimeline.to(this.$introScrollArrow, 0.5, { opacity: 0, yPercent: 50, ease: Power2.easeIn }).set(this.$introScrollArrow, { yPercent: -80 }).to(this.$introScrollArrow, 0.5, { yPercent: 0, opacity: 1, ease: Power2.easeOut }, '+=0.2').addCallback(function () {
			if (_this2.isArrowAnimating) {
				_this2.scrollArrowTimeline.play(0);
			}
		}, '+=1');
	}
};

w.autoHandle(AnimationIntro);;;var AnimationPartialComet = {
	create: function create(el, axis, duration, dist) {
		var coordsFrom = IsometricMotion.get(axis, -dist / 2);
		var coordsTo = IsometricMotion.get(axis, dist / 2);

		var tl = new TimelineMax({
			repeat: -1,
			repeatDelay: Math.random() * 0.5 + 0.5
		});
		tl.fromTo(el, duration / 2, $.extend({ opacity: 0 }, coordsFrom), { opacity: 1, x: 0, y: 0, ease: Power0.easeNone }).to(el, duration / 2, $.extend({ opacity: 0, ease: Power0.easeNone }, coordsTo));
		return tl;
	}
};
;;var AnimationNumber = {
	create: function create($element, duration, ease, number, format) {
		var data = {
			val: 0
		};
		return TweenMax.to(data, duration, {
			val: number,
			ease: ease,
			onUpdate: function onUpdate() {
				$element[0].innerHTML = format.replace('%n', Math.round(data.val, 0).toLocaleString('en-US').replace(/\..*/, ''));
			}
		});
	}
};
;;var AnimationMalware = {
	svgIdPrefix: '#svg-malware-',
	tweens: [],
	swingEase: CustomEase.create("swing", "M0,0,C0.25,0,0.25,1,0.5,1,0.75,1,0.75,0,1,0"),
	isLoopCreated: false,
	hasPlayed: false,

	createLoop: function createLoop() {
		var _this3 = this;

		if (this.isLoopCreated) {
			return;
		}

		if (!$(this.svgIdPrefix + 'Layer_1').length) {
			return;
		}

		//=========================== COMETS ===========================

		var comets = [{ $el: $(this.svgIdPrefix + 'comet1-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet7-neg-z'), axis: IsometricSystem.axis.NEG_Z }, { $el: $(this.svgIdPrefix + 'comet8-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet9-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet11-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet12-pos-x'), axis: IsometricSystem.axis.POS_X }];

		comets.forEach(function (comet) {
			var cometTl = AnimationPartialComet.create(comet.$el, comet.axis, Math.random() * 2 + 4, Math.random() * 300 + 200);
			cometTl.progress(Math.random());
			_this3.tweens.push(cometTl);
		});

		//=========================== EARTH ===========================

		var $earth = $(this.svgIdPrefix + 'earth');
		var earthDisplacement = 20; //Transform in pixels
		var earthTl = new TimelineMax({ repeat: -1 });

		earthTl.fromTo($earth, 4, { y: -earthDisplacement }, { y: earthDisplacement, ease: Sine.easeInOut }).to($earth, 4, { y: -earthDisplacement, ease: Sine.easeInOut });

		this.tweens.push(earthTl);

		//=========================== AVAST LOGOS ===========================

		var $avastLogos = $(this.svgIdPrefix + 'avast-logos-g').children();
		TweenMax.set($avastLogos, { transformOrigin: '50% 50%' });
		var logosTl = new TimelineMax({ repeat: -1, repeatDelay: 1 });
		var logosTween = TweenMax.staggerFromTo($avastLogos, 0.5, { scale: 1 }, { scale: 1.5, ease: this.swingEase }, 0.4);
		logosTl.add(logosTween);

		this.tweens.push(logosTl);

		//=========================== GLOW ===========================

		var $glow = $(this.svgIdPrefix + 'projector-glow');
		$glow = $glow.add(this.svgIdPrefix + 'earth-glow');

		var glowTl = new TimelineMax({ repeat: -1 });
		glowTl.to($glow, 1.5, { opacity: 0.4, ease: this.swingEase }, 1).to($glow, 2, { opacity: 0.3, ease: this.swingEase }, '+=1').to($glow, 1, { opacity: 0.5, ease: this.swingEase }, '+=0.5').to($glow, 2.5, { opacity: 0.4, ease: this.swingEase }, '+=1');

		this.tweens.push(glowTl);

		this.isLoopCreated = true;
	},
	play: function play() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.createLoop();
		this.tweens.forEach(function (tl) {
			TweenMax.to(tl, duration, { timeScale: 1 });
			tl.resume();
		});
		this.hasPlayed = true;
	},
	pause: function pause() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.tweens.forEach(function (tl) {
			return TweenMax.to(tl, duration, {
				timeScale: 0,
				onComplete: function onComplete() {
					tl.pause();
				}
			});
		});
	}
};
;;var AnimationAi = {
	svgIdPrefix: '#svg-ai-',
	tweens: [],
	swingEase: CustomEase.create("swing", "M0,0,C0.25,0,0.25,1,0.5,1,0.75,1,0.75,0,1,0"),
	isLoopCreated: false,
	hasPlayed: false,

	createLoop: function createLoop() {
		var _this4 = this;

		if (this.isLoopCreated) {
			return;
		}

		if (!$(this.svgIdPrefix + 'Layer_1').length) {
			return;
		}

		//=========================== COMETS ===========================

		var comets = [{ $el: $(this.svgIdPrefix + 'comet2-neg-x'), axis: IsometricSystem.axis.NEG_X }, { $el: $(this.svgIdPrefix + 'comet4-neg-x'), axis: IsometricSystem.axis.NEG_X }, { $el: $(this.svgIdPrefix + 'comet6-neg-x'), axis: IsometricSystem.axis.NEG_X }, { $el: $(this.svgIdPrefix + 'comet8-neg-x'), axis: IsometricSystem.axis.NEG_X }, { $el: $(this.svgIdPrefix + 'comet10-neg-x'), axis: IsometricSystem.axis.NEG_X }, { $el: $(this.svgIdPrefix + 'comet12-neg-x'), axis: IsometricSystem.axis.NEG_X }];

		comets.forEach(function (comet) {
			var cometTl = AnimationPartialComet.create(comet.$el, comet.axis, Math.random() * 2 + 4, Math.random() * 300 + 200);
			cometTl.progress(Math.random());
			_this4.tweens.push(cometTl);
		});

		//=========================== CHARTS ===========================

		var $chartsArray = [$(this.svgIdPrefix + 'chart1'), $(this.svgIdPrefix + 'chart2'), $(this.svgIdPrefix + 'chart3'), $(this.svgIdPrefix + 'chart4'), $(this.svgIdPrefix + 'chart5')];

		$chartsArray.forEach(function ($chart) {
			var displacement = Helpers.rnd(5, 10);
			var duration = Math.random() * 2 + 2;
			var fromCoords = IsometricMotion.get(IsometricSystem.axis.POS_X, displacement);
			var toCoords = IsometricMotion.get(IsometricSystem.axis.NEG_X, displacement);
			var tl = new TimelineMax({ repeat: -1 });

			tl.fromTo($chart, duration, fromCoords, $.extend({ ease: Sine.easeInOut }, toCoords)).to($chart, duration, $.extend({ ease: Sine.easeInOut }, fromCoords)).progress(Math.random());

			_this4.tweens.push(tl);
		});

		//=========================== EARTH ORBITS ===========================

		var $orbits = $(this.svgIdPrefix + 'orbits-g').children();
		$orbits.each(function (idx, el) {
			var $orbit = $(el);
			var duration = Math.random() + 0.5;
			var tl = new TimelineMax({ repeat: -1 });
			tl.fromTo($orbit, duration, { drawSVG: '0% 0%' }, { drawSVG: '0% 100%', ease: Power0.easeNone }).to($orbit, duration, { drawSVG: '100% 100%', ease: Power0.easeNone }).progress(Math.random());

			_this4.tweens.push(tl);
		});

		this.isLoopCreated = true;
	},
	play: function play() {
		this.createLoop();
		this.tweens.forEach(function (tl) {
			return tl.resume();
		});
		this.hasPlayed = true;
	},
	pause: function pause() {
		this.tweens.forEach(function (tl) {
			return tl.pause();
		});
	},
	pauseSmooth: function pauseSmooth(duration) {
		this.tweens.forEach(function (tl) {
			return TweenMax.to(tl, duration, { timeScale: 0 });
		});
	}
};
;;var AnimationLocation = {
	svgIdPrefix: '#svg-loc-',
	tweens: [],
	swingEase: CustomEase.create("swing", "M0,0,C0.25,0,0.25,1,0.5,1,0.75,1,0.75,0,1,0"),
	bounceEase: CustomEase.create("bounce", "M0,0 C0.102,0.376 0.103,1 0.32,1 0.588,1 0.428,0 1,0"),
	isLoopCreated: false,
	hasPlayed: false,

	createLoop: function createLoop() {
		var _this5 = this;

		if (this.isLoopCreated) {
			return;
		}

		if (!$(this.svgIdPrefix + 'Layer_1').length) {
			return;
		}

		//=========================== COMETS ===========================

		var comets = [{ $el: $(this.svgIdPrefix + 'comet2-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet4-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet6-pos-z'), axis: IsometricSystem.axis.POS_Z }, { $el: $(this.svgIdPrefix + 'comet8-pos-x'), axis: IsometricSystem.axis.POS_X }, { $el: $(this.svgIdPrefix + 'comet10-neg-z'), axis: IsometricSystem.axis.NEG_Z }];

		comets.forEach(function (comet) {
			var cometTl = AnimationPartialComet.create(comet.$el, comet.axis, Math.random() * 2 + 4, Math.random() * 300 + 200);
			cometTl.progress(Math.random());
			_this5.tweens.push(cometTl);
		});

		//=========================== GLOW ===========================

		var $glow = $(this.svgIdPrefix + 'projector-glow');

		var glowTl = new TimelineMax({ repeat: -1 });
		glowTl.to($glow, 1.5, { opacity: 0.4, ease: this.swingEase }, 1).to($glow, 2, { opacity: 0.3, ease: this.swingEase }, '+=1').to($glow, 1, { opacity: 0.5, ease: this.swingEase }, '+=0.5').to($glow, 2.5, { opacity: 0.4, ease: this.swingEase }, '+=1');

		this.tweens.push(glowTl);

		//=========================== PINS ===========================

		var $pin1 = $(this.svgIdPrefix + 'pin1');
		var $pin2 = $(this.svgIdPrefix + 'pin2');
		var pinDisplacement = -40;

		var pinTl = new TimelineMax({ repeat: -1, repeatDelay: 1 });
		pinTl.to($pin1, 1, { y: pinDisplacement, ease: this.bounceEase }).to($pin2, 1, { y: pinDisplacement, ease: this.bounceEase }, 0.6);

		this.tweens.push(pinTl);

		//=========================== WORDS ===========================

		var $school = $(this.svgIdPrefix + 'school');
		var $work = $(this.svgIdPrefix + 'work');
		var wordDisplacement = 5; //Transform in pixels

		var schoolTl = new TimelineMax({ repeat: -1 });

		schoolTl.fromTo($school, 3, { y: -wordDisplacement }, { y: wordDisplacement, ease: Sine.easeInOut }).to($school, 3, { y: -wordDisplacement, ease: Sine.easeInOut }).progress(Math.random());

		var workTl = new TimelineMax({ repeat: -1 });

		workTl.fromTo($work, 3, { y: -wordDisplacement }, { y: wordDisplacement, ease: Sine.easeInOut }).to($work, 3, { y: -wordDisplacement, ease: Sine.easeInOut }).progress(Math.random());

		this.tweens.push(schoolTl);
		this.tweens.push(workTl);

		this.isLoopCreated = true;
	},
	play: function play() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.createLoop();
		this.tweens.forEach(function (tl) {
			TweenMax.to(tl, duration, { timeScale: 1 });
			tl.resume();
		});
		this.hasPlayed = true;
	},
	pause: function pause() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.tweens.forEach(function (tl) {
			return TweenMax.to(tl, duration, {
				timeScale: 0,
				onComplete: function onComplete() {
					tl.pause();
				}
			});
		});
	}
};
;;var AnimationSecurity = {
	svgIdPrefix: '#svg-sec-',
	tweens: [],
	swingEase: CustomEase.create("swing", "M0,0,C0.25,0,0.25,1,0.5,1,0.75,1,0.75,0,1,0"),
	isLoopCreated: false,
	hasPlayed: false,

	createLoop: function createLoop() {
		var _this6 = this;

		if (this.isLoopCreated) {
			return;
		}

		if (!$(this.svgIdPrefix + 'Layer_1').length) {
			return;
		}

		//=========================== COMETS ===========================

		var comets = [{ $el: $(this.svgIdPrefix + 'comet1-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet3-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet7-neg-x'), axis: IsometricSystem.axis.NEG_X }, { $el: $(this.svgIdPrefix + 'comet9-pos-z'), axis: IsometricSystem.axis.POS_Z }, { $el: $(this.svgIdPrefix + 'comet13-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet15-pos-z'), axis: IsometricSystem.axis.POS_Z }];

		comets.forEach(function (comet) {
			var cometTl = AnimationPartialComet.create(comet.$el, comet.axis, Math.random() * 2 + 4, Math.random() * 300 + 200);
			cometTl.progress(Math.random());
			_this6.tweens.push(cometTl);
		});

		//=========================== CLOUD ===========================

		var $cloud = $(this.svgIdPrefix + 'cloud');
		var cloudDisplacement = 10;
		var cloudTl = new TimelineMax({ repeat: -1 });
		cloudTl.fromTo($cloud, 2, { y: -cloudDisplacement }, { y: cloudDisplacement, ease: Sine.easeInOut }).to($cloud, 2, { y: -cloudDisplacement, ease: Sine.easeInOut });

		this.tweens.push(cloudTl);

		//=========================== ROUTER LEDS ===========================

		var $routerLeds = $(this.svgIdPrefix + 'router-leds-g path');
		var ledCount = $routerLeds.length;
		var ledBlinkDuration = 0.1;
		var getRandomLed = function getRandomLed() {
			return $routerLeds.eq(Math.floor(Math.random() * (ledCount - 1)) + 1);
		};
		var ledTl = new TimelineMax({ repeat: -1, repeatDelay: ledBlinkDuration });
		ledTl.add(function () {
			var $currentLed = getRandomLed();
			TweenMax.set($currentLed, { opacity: 0 });
			TweenMax.set($currentLed, { opacity: 1, delay: ledBlinkDuration });
		});

		this.tweens.push(ledTl);

		//=========================== SHIELD ===========================

		var $shieldGhost = $(this.svgIdPrefix + 'shield-ghost');
		var shieldTl = new TimelineMax({ repeat: -1, repeatDelay: 1 });

		TweenMax.set($shieldGhost, { transformOrigin: '50% 50%' });
		shieldTl.to($shieldGhost, 1, { opacity: 0, scale: 1.6, ease: Power3.easeOut });

		this.tweens.push(shieldTl);

		//=========================== CONNECTIONS ===========================

		var $connections = $(this.svgIdPrefix + 'connections');
		var connectionsTl = new TimelineMax({ repeat: -1 });
		connectionsTl.to($connections, 1, { opacity: 0.8, ease: this.swingEase }, 0.5).to($connections, 0.5, { opacity: 0.75, ease: this.swingEase }, '+=0.4').to($connections, 0.7, { opacity: 0.85, ease: this.swingEase }, '+=0.6').to($connections, 0.8, { opacity: 0.65, ease: this.swingEase }, '+=0.8');

		this.tweens.push(connectionsTl);

		this.isLoopCreated = true;
	},
	play: function play() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.createLoop();
		this.tweens.forEach(function (tl) {
			TweenMax.to(tl, duration, { timeScale: 1 });
			tl.resume();
		});
		this.hasPlayed = true;
	},
	pause: function pause() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.tweens.forEach(function (tl) {
			return TweenMax.to(tl, duration, {
				timeScale: 0,
				onComplete: function onComplete() {
					tl.pause();
				}
			});
		});
	}
};
;;var AnimationDevice = {
	svgIdPrefix: '#svg-dev-',
	tweens: [],
	swingEase: CustomEase.create("swing", "M0,0,C0.25,0,0.25,1,0.5,1,0.75,1,0.75,0,1,0"),
	isLoopCreated: false,
	hasPlayed: false,

	createLoop: function createLoop() {
		var _this7 = this;

		if (this.isLoopCreated) {
			return;
		}

		if (!$(this.svgIdPrefix + 'Layer_1').length) {
			return;
		}

		//=========================== COMETS ===========================

		var comets = [{ $el: $(this.svgIdPrefix + 'comet1-neg-z'), axis: IsometricSystem.axis.NEG_Z }, { $el: $(this.svgIdPrefix + 'comet3-neg-z'), axis: IsometricSystem.axis.NEG_Z }, { $el: $(this.svgIdPrefix + 'comet5-pos-z'), axis: IsometricSystem.axis.POS_Z }, { $el: $(this.svgIdPrefix + 'comet7-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet9-pos-y'), axis: IsometricSystem.axis.POS_Y }, { $el: $(this.svgIdPrefix + 'comet11-neg-x'), axis: IsometricSystem.axis.NEG_X }];

		comets.forEach(function (comet) {
			var cometTl = AnimationPartialComet.create(comet.$el, comet.axis, Math.random() * 2 + 6, Math.random() * 300 + 200);
			cometTl.progress(Math.random());
			_this7.tweens.push(cometTl);
		});

		//=========================== PROGRESS ===========================

		var $progress = $(this.svgIdPrefix + 'progress');
		var progressDisplacement = 20;
		var progressFromCoords = IsometricMotion.get(IsometricSystem.axis.POS_Z, progressDisplacement);
		var progressToCoords = IsometricMotion.get(IsometricSystem.axis.NEG_Z, progressDisplacement);
		var progressTl = new TimelineMax({ repeat: -1 });

		progressTl.fromTo($progress, 5, progressFromCoords, $.extend({ ease: Sine.easeInOut }, progressToCoords)).to($progress, 5, $.extend({ ease: Sine.easeInOut }, progressFromCoords)).progress(Math.random());

		this.tweens.push(progressTl);

		//=========================== PROGRESS BAR ===========================

		var $progressBarMask = $(this.svgIdPrefix + 'progressmask');
		var $progress100 = $(this.svgIdPrefix + 'progress-100');
		var progressBarTl = new TimelineMax();
		progressBarTl.from($progressBarMask, 5, $.extend({ ease: Power0.easeNone }, IsometricMotion.get(IsometricSystem.axis.NEG_X, 180))).from($progress100, 1, { opacity: 0, yPercent: 20, ease: Power3.easeOut });

		this.tweens.push(progressBarTl);

		//=========================== PIE CHARTS ===========================

		var $pieChart = $(this.svgIdPrefix + 'pie-chart');
		var pieChartDisplacement = 15;
		var pieChartFromCoords = IsometricMotion.get(IsometricSystem.axis.POS_Z, pieChartDisplacement);
		var pieChartToCoords = IsometricMotion.get(IsometricSystem.axis.NEG_Z, pieChartDisplacement);
		var pieChartTl = new TimelineMax({ repeat: -1 });

		pieChartTl.fromTo($pieChart, 4, pieChartFromCoords, $.extend({ ease: Sine.easeInOut }, pieChartToCoords)).to($pieChart, 4, $.extend({ ease: Sine.easeInOut }, pieChartFromCoords)).progress(Math.random());

		this.tweens.push(pieChartTl);

		var $pieChart2 = $(this.svgIdPrefix + 'pie-chart2');
		var pieChartDisplacement2 = 10;
		var pieChartFromCoords2 = IsometricMotion.get(IsometricSystem.axis.POS_Z, pieChartDisplacement2);
		var pieChartToCoords2 = IsometricMotion.get(IsometricSystem.axis.NEG_Z, pieChartDisplacement2);
		var pieChartTl2 = new TimelineMax({ repeat: -1 });

		pieChartTl2.fromTo($pieChart2, 6, pieChartFromCoords2, $.extend({ ease: Sine.easeInOut }, pieChartToCoords2)).to($pieChart2, 6, $.extend({ ease: Sine.easeInOut }, pieChartFromCoords2)).progress(Math.random());

		this.tweens.push(pieChartTl2);

		//=========================== ARROW ===========================

		var $arrow = $(this.svgIdPrefix + 'arrow');
		var arrowTl = new TimelineMax({ repeat: -1, repeatDelay: 1 });
		arrowTl.to($arrow, 0.5, { opacity: 0, yPercent: 50, ease: Power2.easeIn }).set($arrow, { yPercent: -50 }).to($arrow, 0.5, { yPercent: 0, opacity: 1, ease: Power2.easeOut }, '+=0.2');

		this.tweens.push(arrowTl);

		this.isLoopCreated = true;
	},
	play: function play() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.createLoop();
		this.tweens.forEach(function (tl) {
			TweenMax.to(tl, duration, { timeScale: 1 });
			tl.resume();
		});
		this.hasPlayed = true;
	},
	pause: function pause() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.tweens.forEach(function (tl) {
			return TweenMax.to(tl, duration, {
				timeScale: 0,
				onComplete: function onComplete() {
					tl.pause();
				}
			});
		});
	}
};
;;var AnimationLayers = {
	svgIdPrefix: '#svg-layers-',
	tweens: [],
	swingEase: CustomEase.create("swing", "M0,0 C0.164,0 0.104,1 0.5,1 0.892,1 0.818,0 1,0"),
	isLoopCreated: false,
	hasPlayed: false,

	createLoop: function createLoop() {
		var _this8 = this;

		if (this.isLoopCreated) {
			return;
		}

		if (!$(this.svgIdPrefix + 'Layer_1').length) {
			return;
		}

		//=========================== COMETS ===========================

		var comets = [{ $el: $(this.svgIdPrefix + 'comet1-neg-z'), axis: IsometricSystem.axis.NEG_Z }, { $el: $(this.svgIdPrefix + 'comet2-neg-z'), axis: IsometricSystem.axis.NEG_Z }, { $el: $(this.svgIdPrefix + 'comet3-neg-z'), axis: IsometricSystem.axis.NEG_Z }, { $el: $(this.svgIdPrefix + 'comet4-neg-z'), axis: IsometricSystem.axis.NEG_Z }, { $el: $(this.svgIdPrefix + 'comet5-neg-z'), axis: IsometricSystem.axis.NEG_Z }];

		comets.forEach(function (comet) {
			var cometTl = AnimationPartialComet.create(comet.$el, comet.axis, Math.random() * 2 + 4, Math.random() * 300 + 200);
			cometTl.progress(Math.random());
			_this8.tweens.push(cometTl);
		});

		//=========================== VIRUSES ===========================

		var $viruses = $(this.svgIdPrefix + 'viruses');

		var virusTl = new TimelineMax({ repeat: -1 });
		virusTl.to($viruses, 1, { opacity: 0.8, ease: this.swingEase }, 0.5).to($viruses, 0.5, { opacity: 0.75, ease: this.swingEase }, '+=0.4').to($viruses, 0.7, { opacity: 0.85, ease: this.swingEase }, '+=0.6').to($viruses, 0.8, { opacity: 0.65, ease: this.swingEase }, '+=0.8');

		this.tweens.push(virusTl);

		//=========================== CLOUD ===========================

		var $cloud = $(this.svgIdPrefix + 'cloud');
		var cloudDisplacement = 5;
		var cloudTl = new TimelineMax({ repeat: -1 });
		cloudTl.fromTo($cloud, 2, { y: -cloudDisplacement }, { y: cloudDisplacement, ease: Sine.easeInOut }).to($cloud, 2, { y: -cloudDisplacement, ease: Sine.easeInOut });

		this.tweens.push(cloudTl);

		//=========================== LAYERS ===========================

		var $layers = [$(this.svgIdPrefix + 'layer1'), $(this.svgIdPrefix + 'layer2'), $(this.svgIdPrefix + 'layer3'), $(this.svgIdPrefix + 'layer4'), $(this.svgIdPrefix + 'layer5'), $(this.svgIdPrefix + 'layer6')];
		var layerBlinkDuration = 0.3;
		var layerTl = new TimelineMax({ repeat: -1 });
		layerTl.staggerFromTo($layers, layerBlinkDuration, { opacity: 1 }, { opacity: 0, ease: this.swingEase }, layerBlinkDuration / 3);

		this.tweens.push(layerTl);

		this.isLoopCreated = true;
	},
	play: function play() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.createLoop();
		this.tweens.forEach(function (tl) {
			TweenMax.to(tl, duration, { timeScale: 1 });
			tl.resume();
		});
		this.hasPlayed = true;
	},
	pause: function pause() {
		var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.2;

		this.tweens.forEach(function (tl) {
			return TweenMax.to(tl, duration, {
				timeScale: 0,
				onComplete: function onComplete() {
					tl.pause();
				}
			});
		});
	}
};